<template>
  <div>
    <van-row
      type="flex"
      justify="center"
      align="center"
      :style="{ height: contentHeight + 'px' }"
    >
      <van-col class="loading">
        <van-row
          type="flex"
          justify="center"
          align="center"
          style="height:50px;"
        >
          <van-col>
            <van-loading type="spinner" color="black" />
          </van-col>
        </van-row>
      </van-col>
    </van-row>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import appConsts from "@/store/consts.js";
import memberService from "@/services/memberService.js";
import tokenService from "@/services/tokenService.js";
import settingService from "@/services/settingService.js";

export default {
  computed: {
    contentHeight() {
      return document.documentElement.clientHeight;
    },
    ...mapState({
      options: (state) => state.orderModule.options,
      member: state => state.memberModule.member
    })
  },
  async created() {
    let tokenResult = await memberService.loginFromWeChatAsync({
      code: this.$route.query.code,
      state: this.$route.query.state
    });
    tokenService.setToken(tokenResult.access_token);
    await this.loadOrderOptionsAsync();
    await this.loadMemberAsync();
    if (this.member.isWeChatSubscribed === false) {
      const options = await settingService.getOptionsAsync();
      if (options && options.WxSubscribeUrl) {
        this.$router.replace({
          name: "SubscribeWeChat",
          params: { subscribeUrl: options.WxSubscribeUrl }
        });
        return;
      }
    }

    //await settingService.configWxJsApi();

    if (this.$route.query.redirect) {
      this.$router.replace((this.$route.query.redirect.indexOf("/") == 0 ? "" : "/") + this.$route.query.redirect);
    } else {
      this.$router.replace("/");
    }
  },
  methods: {
    ...mapActions("memberModule", [appConsts.loadMemberAsync]),
    ...mapActions("orderModule", [appConsts.loadOrderOptionsAsync]),
  }
}; 
</script>

<style lang="scss" scoped>
.loading {
  background-color: rgb(124, 124, 124);
  width: 50px;
  height: 50px;
  border-radius: 5%;
}
</style>
